import { updateProfile } from '@redux/features/UserReducer';
import { ProxyLink } from '@common/constants';
import { linkProxy } from '@common/utils';
import { IGetProfileReq, IGetProfileRes, IProfile } from 'interface/Profile';

export const getProfile = async (id: string, dispatch: any) => {
	try {
		const postData: IGetProfileReq = {
			data_id: id,
		};

		const response = await linkProxy(ProxyLink.UserProfile, postData, ProxyLink.EntryId);

		if (response?.data) {
			const profileData: IGetProfileRes = response?.data?.data;

			if (profileData && !Array.isArray(profileData) && typeof profileData === 'object') {
				const formatedData: IProfile = {
					nric: profileData.nric,
					passport: profileData.passport,
					name: profileData.name,
					dateOfBirth: profileData.dob,
					gender: profileData.gender,
					nationality: profileData.nationality,
					residenceAddress1: profileData.address_line_1,
					residenceAddress2: profileData.address_line_2,
					residenceAddress3: profileData.address_line_3,
					// residenceCity: profileData.city,
					residencePostcode: profileData.postcode,
					residenceState: profileData.province,
					residenceCountry: profileData.country,
					graduatedYear: profileData.graduated_year,
					mobileNo: profileData.mobile_malaysia,
					mobileNoOther: profileData.mobile_other,
					email: profileData.email,
					schoolFaculty: profileData.faculty,
					highestProgramGraduated: profileData.highest_program_graduated,
					campus: profileData.campus,
					employmentType: profileData.employment_type ?? '',
					employmentIndustrySector: profileData.employment_industry ?? '',
					employmentFunction: profileData.employment_function ?? '',
					region: profileData.preferred_region ?? '',
					isResetPassword: profileData.is_reset_password === 'Yes' ? true : false,
					hasExpiryDate: profileData.is_reset_password === 'Yes' ? true : false,
				};

				dispatch(updateProfile(formatedData));

				return true;
			}
		} else {
			throw new Error('Connect Error.');
		}
	} catch (err) {
		if (err instanceof Error) {
			throw new Error(err.message);
		} else {
			throw new Error(`Unknown error: ${err}`);
		}
	}
};
